import React from "react";
import { connect } from "react-redux";
import { addFavItem, removeFavItem } from "../actions/fav";
import { fetchApi } from "../api";
import { STYLES } from "../assets/styles";
import CustomIcon from "./CustomIcon";

function Like({
  data,
  style = {},
  removeFavItem,
  addFavItem,
  favItems,
  loginData = {},
  navigation,
}) {
  const handleItemLiked = ({ _id, title, image_url }) => {
    fetchApi({
      path: "/favitems",
      method: "POST",
      body: {
        item_id: _id,
        title,
        image_url,
      },
    }).then((res) => {
      if (!res.error) {
        addFavItem(res);
      }
    });
  };

  const handleRemoveLiked = ({ _id, item_id }) => {
    fetchApi({
      path: `/favitems/${_id}`,
      method: "DELETE",
    }).then((res) => {
      if (!res.error) {
        removeFavItem({ item_id, _id });
      }
    });
  };

  const handleOnPress = () => {
    if (!loginData.is_guest) {
      if (favItems[data._id] !== undefined) {
        handleRemoveLiked(favItems[data._id]);
      } else {
        handleItemLiked(data);
      }
    } else {
      navigation.navigate("tabs", { screen: "favourite" });
    }
  };

  return (
    <CustomIcon
      type="FontAwesome"
      name="heart"
      onPress={handleOnPress}
      style={{
        fontSize: STYLES.fontSizes.small,
        position: "absolute",
        right: 10,
        top: 10,
        color: favItems[data._id] ? STYLES.colors.tomato : "grey",
        backgroundColor: STYLES.colors.powderWhite,
        borderRadius: 20,
        ...style,
      }}
    />
  );
}

const mapStateToProps = (state) => ({
  favItems: state.fav.itemsIds,
  loginData: state.user.loginData,
});

const mapDispatchToProps = (dispatch) => ({
  addFavItem: (data) => dispatch(addFavItem(data)),
  removeFavItem: (data) => dispatch(removeFavItem(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Like);
